import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";
import type { DropdownConfig } from "@/constants/navigationContexts";

interface NavDropdownMenuProps {
  config: DropdownConfig;
  onItemClick?: () => void;
}

const NavDropdownMenu = ({ config, onItemClick }: NavDropdownMenuProps) => {
  return (
    <div className="w-[280px] p-3 bg-popover">
      <div className="grid gap-1">
        {config.items.map((item, index) => (
          <div key={item.path + item.label}>
            {item.divider && index > 0 && (
              <div className="my-2 h-px bg-border" />
            )}
            <Link
              to={item.path}
              onClick={onItemClick}
              className={cn(
                "flex items-center gap-3 rounded-md px-3 py-2 text-sm transition-colors",
                "hover:bg-accent hover:text-accent-foreground",
                "focus:bg-accent focus:text-accent-foreground focus:outline-none",
                item.divider && "font-medium text-primary"
              )}
            >
              {item.icon && (
                <item.icon className="w-4 h-4 text-muted-foreground" />
              )}
              <div className="flex-1">
                <div className="font-medium">{item.label}</div>
                {item.description && (
                  <p className="text-xs text-muted-foreground line-clamp-1">
                    {item.description}
                  </p>
                )}
              </div>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default NavDropdownMenu;
